import { createFileRoute } from "@tanstack/react-router";
import { UseCasePage } from "@/components/blocks/use-cases/UseCasePage";
import { buildUseCaseHead, loadPageLocale } from "@/lib/page-seo";

export const Route = createFileRoute(
	"/{-$locale}/cas-usage/reprise-application-react-native",
)({
	component: () => <UseCasePage useCase="takeover" />,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData ? buildUseCaseHead("takeover", loaderData.locale) : {},
});
